export default __webpack_public_path__ + "static/media/jbl-c100si.43b95648.png";